<template>
  <div>
    <van-nav-bar
      title="研讨室预约"
      fixed
      placeholder
      left-text="返回"
      right-text="首页"
      left-arrow
      @click-left="goBack"
      @click-right="goHome"
    />
    <div class="h-8 half_circle title-bg"></div>
    <div
      class="
        mx-2
        -mt-8
        p-1.5
        filter
        drop-shadow-md
        bg-white
        grid grid-rows-2 grid-flow-col
      "
    >
      <div class="flex justify-between">
        <span class="middle-text font-extrabold">{{ location }}</span>
      </div>
      <div
        @click="showMap"
        class="middle-text mt-0.5 text-gray-400 font-semibold"
      >
        房间信息&nbsp;&gt;
      </div>
    </div>
    <p class="mx-2 mt-1 small-text text-gray-500">请选择日期与时段</p>
    <div class="mx-2 mt-px p-1 mb-3 bg-white rounded-sm">
      <div class="overflow-x-scroll flex space-x-1">
        <van-button
          round
          plain
          v-for="sday in days"
          :key="sday"
          :class="{ selected: sday === day }"
          @click="selectDay(sday)"
          ><span class="whitespace-nowrap">{{ sday }}</span></van-button
        >
      </div>
      <div class="mt-5 mb-3">
        <div ref="slider"></div>
      </div>
    </div>
    <div class="mx-2 -mt-2 rounded-sm" v-if="maxPerson > 1">
      <div>
        <van-field
          clearable
          center
          label="成员学工号"
          placeholder="请输入成员学号或工号"
          v-model="memberId"
        >
          <template #button>
            <van-button color="#49cfd4" @click="addMember">添加</van-button>
          </template>
        </van-field>
        <van-list v-if="members.length > 0">
          <van-cell
            :title="member.name"
            v-for="member in members"
            :key="member.id"
          >
            <!-- 使用 right-icon 插槽来自定义右侧图标 -->
            <template #right-icon>
              <van-icon name="close" @click="delMember(member.id)" />
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
    <div class="mx-2 mt-1 rounded-md mb-8">
      <van-form>
        <van-field
          clearable
          label="申请标题"
          placeholder="请输入标题"
          required
          v-model="title"
        >
        </van-field>
        <van-field
          clearable
          autosize
          required
          label="申请内容"
          type="textarea"
          placeholder="请输入申请内容"
          v-model="content"
        >
        </van-field>
        <van-field
          type="tel"
          clearable
          required
          label="联系电话"
          placeholder="请输入手机号码"
          v-model="mobile"
        >
        </van-field>
        <van-cell center title="是否公开">
          <template #right-icon>
            <van-switch v-model="isPublic" />
          </template>
        </van-cell>
        <van-field
          name="uploader"
          center
          input-align="right"
          label="申请表"
          v-if="needfile"
        >
          <template #input>
            <van-uploader
              v-model="applicationTable"
              :max-count="1"
              :after-read="afterRead"
            />
          </template>
        </van-field>
      </van-form>
    </div>
    <van-row class="fixed left-0 bottom-0 w-full bg-white small-text">
      <van-col span="6">
        <div class="text-center" @click="goBack">
          <van-icon name="exchange" />
          <p>切换区域</p>
        </div>
      </van-col>
      <van-col span="18">
        <van-button block size="large" @click="bookNow" color="#49cfd4"
          >立即预约</van-button
        >
      </van-col>
    </van-row>
  </div>
  <van-overlay :show="mapShown" @click="mapShown = false">
    <div class="wrapper">
      <van-cell-group inset>
        <van-field label="联系人" :model-value="roomInfo.contacts" readonly />
        <van-field label="邮箱" :model-value="roomInfo.email" readonly />
        <van-field
          label="人数限制"
          :model-value="roomInfo.membercount"
          readonly
        />
        <van-field label="联系地址" :model-value="roomInfo.office" readonly />
        <van-field label="电话" :model-value="roomInfo.phone" readonly />
        <van-field
          label="设备环境"
          :model-value="roomInfo.projector"
          readonly
        />
      </van-cell-group>
    </div>
  </van-overlay>
</template>

<script>
import { ref, toRefs, reactive, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import noUiSlider from "nouislider";
import "nouislider/distribute/nouislider.css";
import Cookies from "js-cookie";
import lrz from "lrz";
import qs from "qs";
// import dayjs from "dayjs";
import {
  myStorage,
  unformatTime,
  formatTime,
  timeFormator,
  filter4Hours,
  findMaxSegment,
} from "../utils/util";
import {
  getMember,
  getOpenDaysByRoom,
  getRoom,
  bookRoom,
} from "@/service/home";
import { Dialog, Toast } from "vant";
export default {
  name: "bookRoom",
  components: {},
  setup() {
    const router = useRouter();
    const user = JSON.parse(Cookies.get("user"));
    const roomId = myStorage.get("room").id;
    const libId = myStorage.get("library").id;
    const slider = ref(null);
    const state = reactive({
      days: [],
      day: "",
      location: myStorage.get("room").nameMerge,
      roomInfo: {},
      mapShown: false,
      rangeStart: 0,
      rangeEnd: 0,
      minTime: 0,
      maxTime: 0,
      minPerson: 0,
      maxPerson: 0,
      needfile: 0,
      bookBeginTime: [],
      bookEndTime: [],
      startTime: "",
      endTime: "",
      isPublic: true,
      title: null,
      content: null,
      mobile: null,
      memberId: null,
      members: [],
      availabeTimeSegments: [],
      applicationTable: [],
    });
    onMounted(async () => {
      const { data, status } = await getOpenDaysByRoom(roomId);
      if (status != 1) {
        Toast.fail("暂无可预约日期");
        return;
      }
      state.days = data.list.map((item) => item.day);
      state.day = myStorage.get("day") || state.days[0];
      init();
    });

    watch(
      () => state.day,
      () => {
        init();
      }
    );
    const init = async () => {
      const {
        rooms,
        msg,
        status: roomStatus,
        needfile,
      } = await getRoom(libId, {
        day: state.day,
        room: roomId,
      });
      if (roomStatus != 1 || rooms == null) {
        Toast.fail(msg);
        return;
      }
      const roomData = rooms[0].detail;
      myStorage.set("roomData", roomData);
      state.roomInfo = roomData.roominfos;
      state.bookBeginTime = roomData.bookbegintime;
      state.bookEndTime = roomData.bookendtime;
      state.rangeStart = unformatTime(roomData.startTime);
      state.rangeEnd = unformatTime(roomData.endTime);
      state.minTime = roomData.minTime;
      state.maxTime = roomData.maxTime;
      const maxSpan = (state.availabeTimeSegments = findMaxSegment(
        state.bookBeginTime,
        state.bookEndTime,
        state.rangeStart,
        state.rangeEnd
      ));
      //console.log(maxSpan);
      const ps = maxSpan[0].segment.ts;
      let pe;
      if (maxSpan[0].span > state.maxTime) {
        pe = ps + state.minTime;
      } else if (maxSpan[0].span > state.minTime) {
        pe = ps + maxSpan[0].span;
      } else {
        Toast.fail("无可用时间段!");
        return false;
      }
      state.needfile = needfile;
      state.minPerson = roomData.minPerson;
      state.maxPerson = roomData.maxPerson;
      state.space = roomData.space;
      const sliderOptions = {
        start: [ps, pe],
        margin: state.minTime,
        limit: state.maxTime,
        behaviour: "tap-drag",
        tooltips: [timeFormator, timeFormator],
        range: {
          min: state.rangeStart,
          max: state.rangeEnd,
        },
        step: 15,
        connect: true,
        pips: {
          mode: "steps",
          density: 4,
          filter: filter4Hours,
          format: timeFormator,
        },
      };
      initSlider(sliderOptions);
    };
    const initSlider = (option) => {
      if (slider.value.noUiSlider) {
        slider.value.noUiSlider.destroy();
      }
      noUiSlider.create(slider.value, option);
      var connect = document.querySelector(".noUi-connect");
      connect.style.zIndex = -1;
      mergeTooltips(slider.value, 20, " - ");
      slider.value.noUiSlider.on("update", function (values) {
        state.startTime = formatTime(values[0]);
        state.endTime = formatTime(values[1]);
      });
      // slider.value.noUiSlider.on("start", function (values, handle) {
      //   let oldValue = values[handle];
      // });
      slider.value.noUiSlider.on("end", function (values, handle, unencoded) {
        var betweenAavailable = false;
        state.availabeTimeSegments.forEach(function (seg) {
          if (
            unencoded[0] >= seg.segment.ts &&
            unencoded[1] <= seg.segment.te
          ) {
            betweenAavailable = true;
            return;
          }
        });
        if (!betweenAavailable) {
          Toast.fail("请选择有效时间段");
          slider.value.noUiSlider.reset();
        }
      });
      setTimeout(() => {
        drawUsedTime(
          state.rangeStart,
          state.rangeEnd,
          state.bookBeginTime,
          state.bookEndTime
        );
      }, 100);
    };
    const goBack = () => router.go(-1);
    const goHome = () => router.push("/index");
    state.day = state.days[0];
    const selectDay = (day) => {
      state.day = day;
    };
    const addMember = async () => {
      if (!state.memberId) {
        Toast.fail("学工号为空");
        return;
      }
      if (state.memberId === user.userid) {
        Toast.fail("不能添加自己");
        return;
      }
      const { status, data } = await getMember(state.memberId, {
        access_token: user.access_token,
        userid: user.userid,
      });
      if (status != 1) {
        Toast.fail("用户不存在");
        return;
      }
      if (
        state.members.filter((item) => item.id == state.memberId).length > 0
      ) {
        Toast.fail("用户已添加");
        return;
      }
      if (state.members.length == state.maxPerson - 1) {
        Toast.fail("成员人数超出");
        return;
      }
      state.members.push(data.list);
      state.memberId = null;
    };
    const delMember = (memberId) => {
      state.members = state.members.filter((item) => item.id != memberId);
    };
    const bookNow = async () => {
      const mobilePattern =
        /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
      if (!state.title || !state.content || !state.mobile) {
        Toast.fail("请完善提交内容");
        return;
      }
      if (!mobilePattern.test(state.mobile)) {
        Toast.fail("手机号码不正确");
        return;
      }
      if (state.maxPerson > 1 && state.members.length == 0) {
        Toast.fail("请添加成员");
        return;
      } else if (
        state.members.length > state.maxPerson - 1 ||
        state.members.length < state.minPerson - 1
      ) {
        Toast.fail("请调整成员人数");
        return;
      }
      const members = state.members.map((item) => item.id);
      if (state.needfile === 1 && state.applicationTable.length == 0) {
        Toast.fail("请上传申请材料");
        return;
      }
      var bookParams = {
        client: 2,
        access_token: user.access_token,
        userid: user.userid,
        id: state.space + "",
        day: state.day,
        startTime: state.startTime,
        endTime: state.endTime,
        title: state.title,
        application: state.content,
        isPublic: state.isPublic,
        mobile: state.mobile,
        teamusers: members,
        operateChannel: 3,
        file: state.needfile == 1 ? state.imgDataUrl.substr(22) : "",
      };
      const bookResult = await bookRoom(state.space, qs.stringify(bookParams));
      if (bookResult.status === 0) {
        Toast.fail(bookResult.msg);
        return;
      } else {
        let body = bookResult.data.list.noticeInfo[0].body;
        let splitted = body.split("。");
        let loc = splitted[0].split("：")[1];
        let time = splitted[1].split("：")[1];
        let members = splitted[2];
        Dialog.alert({
          title: "预约成功",
          allowHtml: true,
          messageAlign: "left",
          message: "地点：" + loc + "\n" + "时间：" + time + "\n" + members,
        }).then(() => {
          router.push("/myRoomBookings");
        });
      }
      //.log(bookResult);
    };
    const afterRead = (file) => {
      lrz(file.file, { width: 960 }).then(function (rst) {
        state.imgDataUrl = rst.base64;
      });
    };
    const showMap = function () {
      state.mapShown = !state.mapShown;
    };

    const drawUsedTime = (min, max, startTimes, endTimes) => {
      removeExistUsedTimes();
      for (let i = 0, len = startTimes.length; i < len; i++) {
        if (startTimes[i] == endTimes[i]) {
          continue;
        }
        drawSingleUsedTime(min, max, startTimes[i], endTimes[i]);
      }
    };

    const drawSingleUsedTime = (min, max, startTime, endTime) => {
      var baseSlider = document.querySelector(".noUi-connects");
      var sliderWidth = baseSlider.offsetWidth;
      var usedTimeDiv = document.createElement("div");
      usedTimeDiv.className = "usedTime";
      usedTimeDiv.style.position = "absolute";
      usedTimeDiv.style.display = "inline-block";
      usedTimeDiv.style.transform =
        "translateX(" +
        ((unformatTime(startTime) - min) / (max - min)) * sliderWidth +
        "px)";
      usedTimeDiv.style.width =
        ((unformatTime(endTime) - unformatTime(startTime)) / (max - min)) *
          100 +
        "%";
      usedTimeDiv.style.background = "red";
      usedTimeDiv.style.height = "50px";
      baseSlider.appendChild(usedTimeDiv);
    };
    const removeExistUsedTimes = () => {
      var existUsedTimes = document.getElementsByClassName("usedTime");
      existUsedTimes = Array.prototype.slice.call(existUsedTimes);
      for (let i = 0, len = existUsedTimes.length; i < len; i++) {
        existUsedTimes[i].parentNode.removeChild(existUsedTimes[i]);
      }
    };
    const mergeTooltips = (slider, threshold, separator) => {
      var textIsRtl = getComputedStyle(slider).direction === "rtl";
      var isRtl = slider.noUiSlider.options.direction === "rtl";
      var isVertical = slider.noUiSlider.options.orientation === "vertical";
      var tooltips = slider.noUiSlider.getTooltips();
      var origins = slider.noUiSlider.getOrigins();

      // Move tooltips into the origin element. The default stylesheet handles this.
      tooltips.forEach(function (tooltip, index) {
        if (tooltip) {
          origins[index].appendChild(tooltip);
        }
      });

      slider.noUiSlider.on(
        "update",
        function (values, handle, unencoded, tap, positions) {
          var pools = [[]];
          var poolPositions = [[]];
          var poolValues = [[]];
          var atPool = 0;

          // Assign the first tooltip to the first pool, if the tooltip is configured
          if (tooltips[0]) {
            pools[0][0] = 0;
            poolPositions[0][0] = positions[0];
            poolValues[0][0] = formatTime(values[0]);
          }

          for (var i = 1; i < positions.length; i++) {
            if (!tooltips[i] || positions[i] - positions[i - 1] > threshold) {
              atPool++;
              pools[atPool] = [];
              poolValues[atPool] = [];
              poolPositions[atPool] = [];
            }

            if (tooltips[i]) {
              pools[atPool].push(i);
              poolValues[atPool].push(formatTime(values[i]));
              poolPositions[atPool].push(positions[i]);
            }
          }

          pools.forEach(function (pool, poolIndex) {
            var handlesInPool = pool.length;

            for (var j = 0; j < handlesInPool; j++) {
              var handleNumber = pool[j];

              if (j === handlesInPool - 1) {
                var offset = 0;

                poolPositions[poolIndex].forEach(function (value) {
                  offset += 1000 - 10 * value;
                });

                var direction = isVertical ? "bottom" : "right";
                var last = isRtl ? 0 : handlesInPool - 1;
                var lastOffset = 1000 - 10 * poolPositions[poolIndex][last];
                offset =
                  (textIsRtl && !isVertical ? 100 : 0) +
                  offset / handlesInPool -
                  lastOffset;

                // Center this tooltip over the affected handles
                tooltips[handleNumber].innerHTML =
                  poolValues[poolIndex].join(separator);
                tooltips[handleNumber].style.display = "block";
                tooltips[handleNumber].style[direction] = offset + "%";
              } else {
                // Hide this tooltip
                tooltips[handleNumber].style.display = "none";
              }
            }
          });
        }
      );
    };
    return {
      goBack,
      goHome,
      selectDay,
      addMember,
      delMember,
      showMap,
      bookNow,
      afterRead,
      slider,
      ...toRefs(state),
    };
  },
};
</script>
<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>